import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { HairSalonService } from 'src/app/shared/services/hair-salon.service';
import { AuthService } from 'src/app/shared/services/authentication.service';
import { LeadType } from '../../interfaces/lead.type';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-hair-salon-lead-form',
  templateUrl: './hair-salon-lead-form.component.html',
  styleUrls: ['./hair-salon-lead-form.component.scss']
})
export class HairSalonLeadFormComponent implements OnInit {

  @Input() hairSalonId: string;

  addLeadForm: FormGroup;
  addLeadSuccess = false;
  isFormSaving = false;

  recaptchaElement;
  isCaptchaElementReady = false;
  isCapchaScriptLoaded = false;
  captchaToken: string;
  capchaObject;
  invalidCaptcha = false;

  @ViewChild('recaptcha') set SetThing(e: HairSalonLeadFormComponent) {
    this.isCaptchaElementReady = true;
    this.recaptchaElement = e;
    if (this.isCaptchaElementReady && this.isCapchaScriptLoaded) {
      this.renderReCaptcha();
    }
  }

  constructor(
    private authService: AuthService,
    private fb: FormBuilder,
    private hairSalonService: HairSalonService,
  ) { }

  ngOnInit(): void {

    this.addLeadForm = this.fb.group({
      first_name: [null, [Validators.required]],
      last_name: [null, [Validators.required]],
      email: [null, [Validators.email, Validators.required]],
      mobile_number: [null, [Validators.required]]
    });
    this.addRecaptchaScript();
  }

  submitForm() {
    for (const i in this.addLeadForm.controls) {
      if (this.addLeadForm.controls[i]) {
        this.addLeadForm.controls[i].markAsDirty();
        this.addLeadForm.controls[i].updateValueAndValidity();
      }
    }

    if (this.findInvalidControls().length === 0) {
      try {
        this.isFormSaving = true;
        this.invalidCaptcha = false;
        if (this.captchaToken) {
          this.isFormSaving = true;
          this.invalidCaptcha = false;
          this.authService.validateCaptcha(this.captchaToken).subscribe((success) => {
            this.saveDataOnServer(this.addLeadForm.value);
          }, (error) => {
            window['grecaptcha'].reset(this.capchaObject);
            this.isFormSaving = false;
            this.invalidCaptcha = true;
          });
        } else {
          this.invalidCaptcha = true;
        }
      } catch (err) {
        this.isFormSaving = false;
      }
    } else {
      this.isFormSaving = false;
    }
  }

  saveDataOnServer(formData) {
    let leadFoundData: LeadType = null;
    if (!this.isFormSaving) { return; }
    this.hairSalonService.getLeadsMonthly(this.hairSalonId).subscribe((res: [any]) => {
      if (res && res.length > 0) {
        const monthlyLeadsList_length = res.length;
        let counter = 0;
        res.forEach(monthlyLead => {
          counter++;
          if (!leadFoundData) {
            this.hairSalonService.getLeadsOfMonth(this.hairSalonId, monthlyLead.id).pipe(take(1)).subscribe((leadsData: [any]) => {
              if (leadsData && leadsData.length > 0) {
                if (!leadFoundData) {
                  leadFoundData = leadsData.find(lead => lead.email === formData.email);
                }
              } else {
              }
              if (leadFoundData) {
                this.addLeadSuccess = true;
                this.isFormSaving = false;
              } else {
                if (counter === monthlyLeadsList_length) {
                  this.hairSalonService.createHairSalonLead(this.hairSalonId, formData).then(data => {
                    this.addLeadForm.reset();
                    this.addLeadSuccess = true;
                    this.isFormSaving = false;
                    setTimeout(() => {
                      this.addLeadSuccess = false;
                    }, 5000);
                    window['grecaptcha'].reset(this.capchaObject);
                  }).catch((error) => {
                    this.isFormSaving = false;
                  });
                }
              }
            }, error => {
              this.addLeadSuccess = false;
              this.isFormSaving = false;
            });
          }
        });
      } else {
        this.hairSalonService.createHairSalonLead(this.hairSalonId, formData).then(data => {
          this.addLeadForm.reset();
          this.addLeadSuccess = true;
          this.isFormSaving = false;
          setTimeout(() => {
            this.addLeadSuccess = false;
          }, 5000);
          window['grecaptcha'].reset(this.capchaObject);
        }).catch((error) => {
          this.isFormSaving = false;
        });
      }
    },
    (error) => {
      this.addLeadSuccess = false;
      this.isFormSaving = false;
    });
  }

  addRecaptchaScript() {
    window['grecaptchaCallback'] = () => {
      this.isCapchaScriptLoaded = true;
      if (this.isCapchaScriptLoaded && this.isCaptchaElementReady) {
        this.renderReCaptcha();
      }
      return;
    };

    (function (d, s, id, obj) {
      let js;
      const fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {
        obj.isCapchaScriptLoaded = true;
        if (obj.isCapchaScriptLoaded && obj.isCaptchaElementReady) {
          obj.renderReCaptcha();
        } return;
      }
      js = d.createElement(s); js.id = id;
      js.src = 'https://www.google.com/recaptcha/api.js?onload=grecaptchaCallback&render=explicit';
      fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'recaptcha-jssdk', this));
  }

  renderReCaptcha() {
    if (!this.recaptchaElement || this.capchaObject) {
      return;
    }

    this.capchaObject = window['grecaptcha'].render(this.recaptchaElement.nativeElement, {
      'sitekey': environment.captchaKey,
      'callback': (response) => {
        this.invalidCaptcha = false;
        this.captchaToken = response;
      },
      'expired-callback': () => {
        this.captchaToken = '';
      }
    });
  }

  public findInvalidControls() {
    const invalid = [];
    const controls = this.addLeadForm.controls;

    for (const name in controls) {
      if (controls[name].invalid) {
        invalid.push(name);
      }
    }
    return invalid;
  }

}
